module.exports = __webpack_public_path__ + "static/media/14UNEP7.589bc5c7.jpg";